import { render, staticRenderFns } from "./ImporterMessageSidebar.vue?vue&type=template&id=601f3f0d&scoped=true&"
import script from "./ImporterMessageSidebar.vue?vue&type=script&lang=ts&"
export * from "./ImporterMessageSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601f3f0d",
  null
  
)

export default component.exports